import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useUtility, Stack, Switch, Tooltip, Text, Button, Checkbox } from '@hub-la/design-system';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const PermissionField = ({
  name,
  value,
  description,
  subpermissions
}) => {
  const [isShowDropdown, setIsShowDropdown] = useState(true);
  const {
    palette
  } = useUtility();
  const {
    t
  } = useTranslation();
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const hasSubPermissions = subpermissions && subpermissions.length > 0;
  const permissionIsEnabled = values.permissions.includes(value);
  const handleSwitchPermissionChange = event => {
    const permissionValue = event.target.value;
    const currentPermissions = values.permissions.slice();
    const permissionIndex = values.permissions.indexOf(permissionValue);
    const permissionIsEnabled = permissionIndex === -1;
    if (permissionIsEnabled) {
      currentPermissions.push(permissionValue);
    } else {
      currentPermissions.splice(permissionIndex, 1);
    }
    if (hasSubPermissions) {
      subpermissions.forEach(subpermission => {
        const subPermissionIndex = currentPermissions.indexOf(subpermission.value);
        const subPermissionIsDisabled = subPermissionIndex !== -1;
        if (subPermissionIsDisabled) {
          currentPermissions.splice(subPermissionIndex, 1);
        }
        if (permissionIsEnabled) {
          currentPermissions.push(subpermission.value);
        }
      });
    }
    setFieldValue('permissions', currentPermissions);
  };
  const handleCheckboxSubPermissionChange = event => {
    const permissionValue = event.target.value;
    const permissions = values.permissions.slice();
    const permissionIndex = values.permissions.indexOf(permissionValue);
    if (permissionIndex !== -1) {
      permissions.splice(permissionIndex, 1);
    } else {
      permissions.push(permissionValue);
    }
    setFieldValue('permissions', permissions);
  };
  return jsxs(Stack, {
    children: [jsxs(Stack, Object.assign({
      direction: "row",
      justifyContent: "space-between"
    }, {
      children: [jsxs(Stack, Object.assign({
        direction: "row",
        alignItems: "center",
        gap: 2
      }, {
        children: [jsx(Switch, {
          marginRight: 0,
          marginLeft: 0,
          label: name,
          direction: "left",
          value: value,
          checked: values.permissions.includes(value),
          onChange: e => handleSwitchPermissionChange(e)
        }), description && jsx(Tooltip, Object.assign({
          trigger: "hover",
          placement: "top",
          title: description,
          arrow: true
        }, {
          children: jsx(InfoIcon, {
            fontSize: "small"
          })
        }))]
      })), hasSubPermissions && jsxs(Stack, Object.assign({
        direction: "row",
        alignItems: "center",
        gap: 2
      }, {
        children: [jsx(Text, Object.assign({
          variant: "body2",
          color: !permissionIsEnabled ? 'outline' : undefined
        }, {
          children: t('collaboratorForm.subpermissionsDetails')
        })), jsx(Button, Object.assign({
          iconOnly: true,
          variant: "text",
          size: "small",
          onClick: () => setIsShowDropdown(!isShowDropdown),
          disabled: !permissionIsEnabled,
          "data-testid": "dropdown-button"
        }, {
          children: permissionIsEnabled && isShowDropdown ? jsx(ArrowDropUp, {}) : jsx(ArrowDropDown, {})
        }))]
      }))]
    })), permissionIsEnabled && isShowDropdown && hasSubPermissions && jsx(Stack, Object.assign({
      mt: 4,
      bgcolor: palette('surfaceAt3'),
      p: 3,
      pl: 6,
      borderRadius: 3,
      gap: 4
    }, {
      children: subpermissions.map(subpermission => jsx(Checkbox, {
        checked: values.permissions.includes(subpermission.value),
        label: t(subpermission.name),
        value: subpermission.value,
        onChange: x => handleCheckboxSubPermissionChange(x)
      }, subpermission.value))
    }))]
  });
};

export { PermissionField };
